import lazyWithRetry from 'tools/lazyWithRetry';

const invoiceReasonComponent = lazyWithRetry(() => import(
	/* webpackChunkName: "InvoiceReasonListPage" */
	'pages/invoice/InvoiceReason/InvoiceReasonListPage'));

const refundReasonComponent = lazyWithRetry(() => import(
	/* webpackChunkName: "RefundReasonListPage" */
	'pages/invoice/InvoiceReason/RefundReasonListPage'));

export default [
	{ component: invoiceReasonComponent, exact: true, path: '/invoice_reasons/invoice' },
	{ component: refundReasonComponent, exact: true, path: '/invoice_reasons/refund' },
];
